import SkeletonLoader from '.';

const AssignedClassesSkeleton = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Search */}
      <SkeletonLoader width={450} height={48} className="rounded-lg" />

      {/* Title */}
      <SkeletonLoader width={200} height={32} />

      {/* Classes Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div
            key={i}
            className="border border-neutral-200 p-4 rounded-2xl space-y-4"
          >
            <div className="flex items-center justify-between">
              <SkeletonLoader width={150} height={24} />
              <SkeletonLoader width={80} height={24} className="rounded-full" />
            </div>
            <div className="flex gap-4">
              {[1, 2, 3].map((j) => (
                <SkeletonLoader
                  key={j}
                  variant="circle"
                  width={32}
                  height={32}
                />
              ))}
            </div>
            <div className="flex items-center justify-between pt-2">
              <SkeletonLoader width={100} height={20} />
              <SkeletonLoader width={60} height={20} />
            </div>
            <SkeletonLoader width="100%" height={8} className="rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssignedClassesSkeleton;
